import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { Howl } from 'howler';
import { UtilsService } from './utils.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./utils.service";
var MainService = /** @class */ (function () {
    function MainService(http, _utilsService) {
        this.http = http;
        this._utilsService = _utilsService;
        this._settingURL = "" + environment.phpApiUrl + '/settings/get-detail/' + ("" + environment.DRAFT_ACCESS_TOKEN);
        this._userTeamURL = "" + environment.phpApiUrl + '/user/teams/' + ("" + environment.DRAFT_ACCESS_TOKEN);
        this.myTeamcursor = 0;
        this.lastStatus = 'drafting';
        this.myTeamPlayers = new EventEmitter();
        this.httpOptions = { headers: new HttpHeaders({}) };
        if (localStorage.getItem('currentUser') == null) {
            window.location.href = environment.SITE_URL + "/logout";
        }
        this.draftUrl = "" + environment.draftUrl;
    }
    MainService.prototype.getSetting = function () {
        return this._utilsService.getRequest(this._settingURL);
    };
    MainService.prototype.getFAQTitles = function () {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/user/getFAQTitles/' + ("" + environment.DRAFT_ACCESS_TOKEN));
    };
    MainService.prototype.getFAQItem = function (id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/user/getFAQItem/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + id);
    };
    MainService.prototype.searchFAQ = function (search) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/user/searchFAQ/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + search);
    };
    MainService.prototype.getActiveDraft = function (user_id, game_id) {
        return this._utilsService.getRequest(this.draftUrl + '/getAllTournamentRecords/' + user_id + '/' + game_id);
    };
    MainService.prototype.getActiveLeague = function (user_id, cursor) {
        return this._utilsService.getRequest(this.draftUrl + '/loadLeagueListRecords/' + user_id + '/' + cursor);
    };
    MainService.prototype.getTeam = function (user_id, status, cursor) {
        var _this = this;
        var key = '0';
        var player = '0';
        var sport = 'all';
        var duration = 'all';
        var direction = '0';
        var limit = '8';
        var order = '0';
        if (this.myTeamcursor < 1 || this.lastStatus !== status || cursor === 0) {
            this.myTeamcursor = 0;
            this.lastStatus = status;
        }
        var TeamURL = this._userTeamURL + '/' + user_id + '/' + key + '/' + player + '/' + sport + '/' + duration + '/' + status + '/' + this.myTeamcursor + '/' + order + '/' + direction + '/' + limit;
        return this.http
            .get(TeamURL, this.httpOptions)
            .pipe(map(function (res) {
            _this.myTeamcursor++;
            return res;
        }));
    };
    MainService.prototype.getPlayerInfoData = function (player_id, season_id, league_id, league_team_id, abbr, draft_status, tab_name) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/player/player-info/' + ("" + environment.DRAFT_ACCESS_TOKEN) +
            '/' + player_id + '/' + season_id + '/' + league_id + '/' + league_team_id + '/' + abbr + '/' + draft_status + '/' + tab_name);
    };
    MainService.prototype.playSound = function () {
        var sound = new Howl({
            src: ["" + environment.assetURL + '/assets/default/media/cool-notifications.mp3'],
            autoplay: true,
            loop: false,
            volume: 1.0,
            onend: function () {
            }
        });
    };
    MainService.prototype.headerNotification = function (user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/settings/header-notification/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + user_id);
    };
    MainService.prototype.userDetail = function (user_id, token) {
        if (user_id === void 0) { user_id = 0; }
        if (token === void 0) { token = null; }
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/user/profile/' + ("" + environment.DRAFT_ACCESS_TOKEN));
    };
    MainService.prototype.getCurrentlyWinning = function (user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/user/getCurrentlyWinning/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + user_id);
    };
    MainService.prototype.sendOTP = function (phone) {
        return this._utilsService.getRequest("" + environment.phpUrl + '/register/send-verification/' + phone);
    };
    MainService.prototype.verifyOTP = function (phone, otp) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/user/checkVerification/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + phone + '/' + otp);
    };
    MainService.prototype.acceptFriendRequest = function (request_uuid, user_id) {
        var data = {
            'request_uuid': request_uuid,
            'user_id': user_id,
            'access_token': "" + environment.DRAFT_ACCESS_TOKEN,
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/friends/accept-request', data, null, 'content-type-json');
    };
    MainService.prototype.rejectFriendRequest = function (request_uuid, user_id) {
        var data = {
            'request_uuid': request_uuid,
            'user_id': user_id,
            'access_token': "" + environment.DRAFT_ACCESS_TOKEN,
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/friends/reject-request', data, null, 'content-type-json');
    };
    MainService.prototype.friendList = function (user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/friends/getallfriendlist/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + user_id);
    };
    MainService.prototype.addNewMessage = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/friends/addnewmsgallfriends', data, null, 'content-type-json');
    };
    MainService.prototype.getPicture = function (img, type, user_id) {
        var imagepath = '';
        if (img) {
            switch (type) {
                case 'users':
                    var path = img.split('/');
                    if (path.length >= 2 && path[path.length - 2] == "preset") {
                        imagepath = "" + environment.assetURL + '/assets/default/images/' + path[path.length - 2] + '/' + path[path.length - 1];
                    }
                    else if (path[path.length - 1] == 'user.png') {
                        imagepath = "" + environment.assetURL + '/assets/default/images/user.png';
                    }
                    else {
                        imagepath = "" + environment.assetURL + '/assets/uploads/users/' + user_id + '/profile/image_50x50/' + path[path.length - 1];
                    }
                    break;
                case 'players':
                    imagepath = "" + environment.assetURL + '/assets/uploads/players/' + img;
                    break;
                case 'gameIcon':
                    imagepath = "" + environment.assetURL + '/assets/default/images/' + img;
                    break;
            }
        }
        return imagepath;
    };
    MainService.prototype.getTiersData = function (league_id, user_id, lgm_id) {
        return this._utilsService.getRequest("" + environment.boxScoreUrl + '/getPickemData/' + league_id + '/' + user_id + '/' + lgm_id);
    };
    MainService.prototype.saveTiersRoster = function (league_id, lgm_id, game_id, roster) {
        var data = {
            lg_id: league_id,
            lgm_id: lgm_id,
            game_id: game_id,
            roster: roster,
            angular: 1
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/league/pickem', data, null, 'content-type-json');
    };
    MainService.prototype.saveRankemRoster = function (league_id, lgm_id, game_id, roster) {
        var data = {
            lg_id: league_id,
            lgm_id: lgm_id,
            game_id: game_id,
            roster: roster,
            angular: 1
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/league/rankem', data, null, 'content-type-json');
    };
    MainService.prototype.rankemQuickJoin = function (lg_abbr, default_set, user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/rankem/quick-join/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + lg_abbr + '/' + default_set + '/' + user_id);
    };
    MainService.prototype.tiersQuickJoin = function (lg_abbr, default_set, user_id, drafttype_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/pickem/quick-join/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + lg_abbr + '/' + default_set + '/' + user_id + '/' + drafttype_id);
    };
    MainService.prototype.handleErrorPost = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            console.error(result); // log to console instead 
            // TODO: better job of transforming error for user consumption
            console.log(operation + " failed: " + error);
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    MainService.prototype.getImageData = function (urls) {
        var data = { 'urls': urls };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/util/getImageData', data, null, 'content-type-json');
    };
    MainService.ngInjectableDef = i0.defineInjectable({ factory: function MainService_Factory() { return new MainService(i0.inject(i1.HttpClient), i0.inject(i2.UtilsService)); }, token: MainService, providedIn: "root" });
    return MainService;
}());
export { MainService };
